import { SurveysService } from "./implementations/surveys.service";

export default defineNuxtPlugin((nuxtApp) => {
  const surveys = new SurveysService(
    nuxtApp.$axios,
    nuxtApp.$config.public.sgApiUrl,
    nuxtApp.$config.public.sgCmsApi
  );

  return {
    provide: {
      surveys: surveys,
    },
  };
});
